import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-area-cliente',
  templateUrl: './area-cliente.component.html',
  styleUrls: ['./area-cliente.component.css']
})
export class AreaClienteComponent implements OnInit {

  config: any = {}

  constructor(
    private configService: ConfigService,
    private titleService: Title
  ) {
    this.getConfig()
  }
  
  ngOnInit(): void {
  }

  getConfig() {
    this.configService.config().subscribe(
      data => {
        this.config = data
        this.titleService.setTitle('Cliente | ' + data.nome)
      }, err => {
      }
    )
  }

}
